import logo from './logo.svg';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Reg from './components/RegistrationPage/Reg';
import Success from './components/SuccessPage/Success';

function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Reg/>}/>
        <Route path='/success' element={<Success/>}/>
      </Routes>
    </>
  );
}

export default App;
